import { InputAdornment, TextField } from '@mui/material'

export default function SearchField({
	searchPlaceholder = 'Search',
	searchValue,
	onSearchChange,
}) {
	const inputSearchStyle = {
		minWidth: 215,
		'& .MuiInputBase-root': {
			borderRadius: '8px',
			paddingLeft: '12px',
			height: '40px',
		},
		'& .MuiInputBase-input': {
			fontSize: '12px',
			fontWeight: '400',
			color: '#000',
			fontFamily: 'Inter',
			'&::placeholder': {
				color: '#8692A4',
				opacity: 1,
			},
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#DFE4EB',
		},
		'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#DFE4EB',
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
			{
				borderColor: '#DFE4EB',
			},
		'@media (max-width: 600px)': {
			minWidth: '100%',
		},
	}
	const inputSearchIconStyle = {
		width: '16px',
		height: '16px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& svg, & img': {
			width: '16px',
			height: '16px',
		},
	}
	return (
		<>
			<TextField
				size="small"
				placeholder={searchPlaceholder}
				value={searchValue}
				onChange={(e) => onSearchChange?.(e.target.value)}
				sx={inputSearchStyle}
				data-cy="vendor-search-input"
				InputProps={{
					'data-cy': 'vendor-search-field',
					startAdornment: (
						<InputAdornment
							position="start"
							sx={inputSearchIconStyle}
						>
							<img
								src="/images/search-icon.svg"
								alt="search-icon.svg"
							/>
						</InputAdornment>
					),
				}}
			/>
		</>
	)
}
